import { EndpointRequest } from "../../_system/EndpointRequest";
import {
  ReservationReserveRequestDto as RequestDto,
  ReservationReserveResponseDto as ResponseDto,
} from "../../api/reservation/reserve/dtos";
import { Api } from "../../api";

export const reserve = new EndpointRequest<RequestDto, ResponseDto>(
  "RESERVE",
  Api.reservation.reserve
);
